import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import { ShoppingCartIcon, ArrowForwardIcon } from "~/theme/assets";
import classnames from "classnames";
import styled from "styled-components";
import { MiniCart } from "@witbooking/react-components";
import styles from "./SummaryCart.scss";

const msgs = defineMessages({
  myBooking: {
    id: "room_selection.summaryCart.myBooking",
    description: "My booking",
    defaultMessage: "My booking",
  },
  view: {
    id: "room_selection.summaryCart.view",
    description: "View",
    defaultMessage: "View",
  },
  delete: {
    id: "room_selection.summaryCart.delete",
    description: "delete",
    defaultMessage: "delete",
  },
  total: {
    id: "room_selection.summaryCart.total",
    description: "Total",
    defaultMessage: "Total",
  },
  bookNow: {
    id: "room_selection.summaryCart.bookNow",
    description: "BOOK NOW",
    defaultMessage: "BOOK NOW",
  },
  emptyCart: {
    id: "cart.emptyCart",
    description: "text in the rigth side cart when is empty ",
    defaultMessage: "Your cart is empty",
  },
});

const SummaryCartModalContainer = styled.div`
  position: absolute;
  top: 15px;
  left: -250px;
  width: 250px;
  background-color: white;
  box-shadow: 2px 3px 7px rgba(0, 0, 0, 0.13);
  z-index: 25;
`;

const SummaryCartIconContainer = styled.div`
  position: relative;
`;

const SummaryTitleIconContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  align-items: center;
`;

const ArrowForwardContainer = styled(ArrowForwardIcon)`
  width: 24px;
  height: 24px;
  margin-right: 10px;
`;

const SummaryCartHeader = styled.div`
  cursor: ${props => (props.numberOfRooms >= 1 ? "pointer" : "")};
  width: 100%;
  height: 50px;
  justify-content: space-around;
  :hover {
    text-decoration: ${props => (props.numberOfRooms >= 1 ? "underline" : "")};
  }
`;

const SummaryCartNumberContainer = styled.div`
  position: absolute;
  background-color: #b20e0e;
  top: -5px;
  right: 5px;
  border-radius: 50px;
  width: 17px;
  height: 17px;
  font-size: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
`;

class SummaryCart extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      renderModal: false,
    };
  }

  onMouseEntering = () => {
    this.setState({ renderModal: true });
  };

  onMouseExiting = () => {
    this.setState({ renderModal: false });
  };

  sumPropertyFromArrayOfObjects = (items, property) => {
    return items.reduce((firstValue, secondValue) => {
      return firstValue + secondValue[property];
    }, 0);
  };

  handleSummaryCartHeaderOnClick = numberOfRooms => {
    if (numberOfRooms >= 1) {
      this.props.handleSubmit();
    }
  };

  render() {
    const {
      currency,
      handleSubmit,
      handleRemoveReservation,
      reservations,
      locale,
      reservationsLenght,
    } = this.props;

    const numberOfRooms = this.sumPropertyFromArrayOfObjects(reservations, "quantity");

    return (
      <div
        className={classnames("wbkv9-SummaryCart-container", styles.container)}
        onMouseEnter={this.onMouseEntering}
        onMouseLeave={this.onMouseExiting}
        ref="refSummaryCart">
        {/** START HEADER*/}
        <SummaryCartHeader
          onClick={() => {
            this.handleSummaryCartHeaderOnClick(numberOfRooms);
          }}
          numberOfRooms={numberOfRooms}
          className={classnames("wbkv9-SummaryCart-header", styles.header)}>
          <SummaryTitleIconContainer>
            <SummaryCartIconContainer
              className={classnames("wbkv9-SummaryCart-headerIcon", styles.headerIcon)}>
              <ShoppingCartIcon />
              {numberOfRooms >= 1 && (
                <SummaryCartNumberContainer className="wbkv9-SummaryCart-IconNumber">
                  {numberOfRooms}
                </SummaryCartNumberContainer>
              )}
            </SummaryCartIconContainer>

            <div className={classnames("wbkv9-SummaryCart-headerTitle", styles.headerTitle)}>
              <FormattedMessage {...msgs.myBooking} />
            </div>
          </SummaryTitleIconContainer>
          {numberOfRooms >= 1 && (
            <div>
              <ArrowForwardContainer />
            </div>
          )}
        </SummaryCartHeader>
        {this.state.renderModal && reservationsLenght >= 1 && (
          <SummaryCartModalContainer>
            <MiniCart
              rooms={reservations}
              handlePay={handleSubmit}
              handleFirstAction={handleSubmit}
              locale={locale}
              handleSecondAction={handleRemoveReservation}
              currency={currency}
            />
          </SummaryCartModalContainer>
        )}
        {/** END HEADER*/}
      </div>
    );
  }
}

SummaryCart.propTypes = {
  cart: PropTypes.object,
  reservations: PropTypes.array,
  reservationsLenght: PropTypes.number,
  currency: PropTypes.string,
  locale: PropTypes.string,
  handleSubmit: PropTypes.func,
  handleRemoveReservation: PropTypes.func,
};

export default injectIntl(SummaryCart);
